/**
 * @file: useAppleSignIn.web.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useCallback } from 'react';

export const isAppleSignInSupported = () => false;

export const useAppleSignIn = () => {
  return useCallback(() => {}, []);
};

export type AppleRealUserStatus = never;
